import { render, staticRenderFns } from "./VesselMonitoringSingleBayHold.vue?vue&type=template&id=316b9684&scoped=true"
import script from "./VesselMonitoringSingleBayHold.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSingleBayHold.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringSingleBayHold.vue?vue&type=style&index=0&id=316b9684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b9684",
  null
  
)

export default component.exports